export default "__VITE_ASSET__d0db2fc8__"